<template>
  <div class="data-center__gallery">
    <swiper-controls
      class="data-center__gallery-controls"
      type="inverse"
    ></swiper-controls>

    <swiper :options="swiperOptions">
      <swiper-slide
        v-for="image in gallery"
        :key="image.id"
        class="data-center__gallery-item"
      >
        <img
          :data-src="image.image"
          alt=""
          class="data-center__gallery-image swiper-lazy"
        >
        <div class="data-center__gallery-preloader swiper-lazy-preloader swiper-lazy-preloader-white"></div>
        <div class="data-center__overlay"></div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
  name: 'DataCenterListGallery',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    gallery: {
      type: Array,
      default: () => []
    },
    dataCenterId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      swiperOptions: {
        grabCursor: true,
        loop: true,
        preloadImages: false,
        lazy: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        pagination: {
          // eslint-disable-next-line id-blacklist
          el: `.data-center__gallery--${this.dataCenterId} .swiper-pagination`,
          type: 'fraction'
        },
        navigation: {
          nextEl: `.data-center__gallery--${this.dataCenterId} .swiper__button--next`,
          prevEl: `.data-center__gallery--${this.dataCenterId} .swiper__button--prev`
        }
      }
    }
  }
}
</script>

<style lang="scss">
.data-center__gallery {
  grid-area: swiper;
  position: relative;
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;

  border-left: 1px solid $grayBorder;
}

.data-center__gallery .data-center__gallery-controls {
  z-index: 11;
  position: absolute;
  bottom: 24px;
  align-self: flex-end;

  @media (max-width: $breakpoint-md) {
    bottom: 16px;
  }
}

.data-center__gallery {
  .swiper-container {
    width: 100%;
    border-radius: 0 12px 12px 0;
    overflow: hidden;

    @media (max-width: $breakpoint-lg) {
      border-radius: 12px 12px 0 0;
    }
  }
}

.data-center__gallery-item {
  position: relative;
}

.data-center__gallery-image {
  min-height: 220px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0 12px 12px 0;
  overflow: hidden;

  @media (max-width: $breakpoint-lg) {
    border-radius: 12px 12px 0 0;
  }
}

.data-center__gallery-preloader {
  z-index: 20;
}

.data-center__overlay {
  z-index: 10;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background: linear-gradient(180deg, rgba(9, 36, 51, 0) 51.7%, rgba(9, 36, 51, 0.5) 100%);

  border-radius: 0 12px 12px 0;
  overflow: hidden;

  @media (max-width: $breakpoint-lg) {
    border-radius: 12px 12px 0 0;
  }
}
</style>